import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// config
import { HEADER } from 'src/config-global';
//
import Header from './header/Header';
// import Header from 'src/components/common/Header';
import Footer from './footer/Footer';

// ----------------------------------------------------------------------

const pathsOnDark = ['/career/landing', '/travel/landing'];

const spacingLayout = [...pathsOnDark, '/', '/gallery', '/layout', '/facilities', '/location', '/developer','/term'];

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();

  const actionPage = (arr) => arr.some((path) => pathname === path);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Header headerOnDark={actionPage(pathsOnDark)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
        }}
      >
        {/* {!actionPage(spacingLayout) && <Spacing />} */}
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}

// ----------------------------------------------------------------------

function Spacing() {
  return (
    <Box
      sx={{
        height: { xs: HEADER.H_MOBILE, md: HEADER.H_MAIN_DESKTOP },
      }}
    />
  );
}
